<template>
  <section class="content-section" id="project-scope">
    <h1>Project Scope</h1>
    <h2>{{ productBrand }} Overview</h2>
    <table class="table scope-table has-smallest-font">
      <tbody>
        <tr>
          <td>Following budget is based on</td>
          <td>
            <li v-for="(doc, docIndex) in documents.value" :key="docIndex">
              <span 
                v-for="(col, i) in documents.bind.rowTemplate"
                :key="i"
              >
                {{ col.component == 'VDatepicker' ? 
                  doc[col.label] ? `[${formatDate(parseDate(doc[col.label]))}]` : null : 
                  doc[col.label]}}
              </span>
            </li>
          </td>
        </tr>
        <tr>
          <td>Material Onsite</td>
          <td>{{ materialOnsite }}</td>
        </tr>
        <tr>
          <td>Quote Type</td>
          <td>{{ quoteType }}</td>
        </tr>
        <tr>
          <td>Notes</td>
          <td><span v-html="notes"></span></td>
        </tr>
      </tbody>
    </table>
    <div class="columns is-multiline">
      <div 
        class="column is-4" 
        v-for="(material, materialIndex) in materials" 
        :key="materialIndex"
      >
        <div class="material">
          <img :src="material.image.url"/>
          <div class="material__desc">
            <div class="is-capitalized">
              {{ material.material_type }}
            </div>
            <div class="material__desc--small is-uppercase has-text-weight-semibold">
              {{ material.material }}
            </div>
            <div class="material__desc--small has-text-weight-semibold">
              {{ material.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="addendum mt-3">
      For more technical information about the product, please view our Mitrex & Cladify product datasheet
    </div>  
  </section>
</template>

<script>
import { rfqQuoteTypes } from '@/data/rfq-quote-types'
import { format, parseJSON } from 'date-fns'

export default {
  props: {
    productBrand: {
      type: String,
      required: true
    },
    proposal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formatDate: (date) => {
        return date ? format(date, "MM/dd/yyyy") : null;
      },
      parseDate: (date) => { return date ? parseJSON(date) : date }
    }
  },
  computed: {
    documents({ proposal }) {
      return proposal.proposal_info.find(info => info.id === 'documents')
    },
    materialOnsite({ proposal }) {
      return proposal.proposal_info.find(info => info.id === 'material_onsite')?.value || ''
    },
    quoteType({ proposal }) {
      const quoteType = proposal.proposal_info.find(info => info.id === 'quote_type')?.value || null
      return quoteType ? rfqQuoteTypes.find(qt => qt.value === quoteType).label : null
    },
    notes({ proposal }) {
      return proposal.proposal_info.find(info => info.id === 'project_scope_notes')?.value || ''
    },
    materials({ proposal }) {
      return proposal.proposal_content
        .find(content => content.id === 'materials')
        ?.subsections.filter(m => m.visible) || []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/table.scss';
.scope-table {
  width: 100%;
  color: #181A19;
  font-weight: lighter;
  tr:not(:last-of-type) {
    border-bottom: 1px solid #D5D3CE;
  }
  td {
    &:first-child {
      width: 250px;
    }
  }
  li {
    list-style: none;
  }
}

.material {
  border: 1px solid #D5D3CE;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  img {
    height: 70px;
    width: auto;
    margin: 5px;
  }

  &__desc {
    height: 100%;
    width: 100%;
    font-size: 0.8em;
    margin-left: 3px;
    margin-bottom: 8px;
    margin-right: 5px;
    &--small {
      font-size: 0.7em;
    }
    font-weight: lighter;
  }
}

.addendum {
  width: 100%;
  font-size: 0.8em;
  font-weight: lighter;
  text-align: center;
}
</style>
